const requests = state => {
	return state.requestLoading
}

const theme = state => {
	return state.theme
}

const showSidebar = state => {
	return state.showSidebar
}

const modules = state => {
	return state.modules
}

const modalities = state => {
	return state.modalities
}

const dicom_modalities = state => {
	return state.dicom_modalities
}

const schedules = state => {
	return state.schedules
}

const icon_size = state => {
	return state.icon_size
}

const carousel_orientation = state => {
	return state.carousel_orientation
}

const menu_order = state => {
	return state.menu_order
}

const last_modality_id = state => {
	return state.last_modality_id
}

const keep_connected = state => {
	return state.keep_connected
}

const favoriteRouteName = state => {
	return state.favoriteRouteName
}

const selectedReceptionCounter = state => {
	return +state.selectedReceptionCounter
}

const hasToolBar = state => {
	return state.toolBar
}

const hasInfoBar = state => {
	return state.infoBar
}

const hasSubtitle = state => {
	return state.subtitle
}

export {
	requests,
	theme,
	showSidebar,
	modules,
	modalities,
	dicom_modalities,
	schedules,
	icon_size,
	carousel_orientation,
	menu_order,
	last_modality_id,
	keep_connected,
	favoriteRouteName,
	selectedReceptionCounter,
	hasToolBar,
	hasInfoBar,
	hasSubtitle,
}
